import styled from "styled-components";

import { Button as AntButton } from "antd";
import { FontFamily, FontSize, ThemesColors } from "@themes/index";
import { EDeviceSize } from "constants/media";

const AuthCheckboxWrapper = styled.div`
    display: flex;
    justify-content: space-between;

    width: 100%;
    margin: 10px 0;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
`;

const AuthIcon = styled.img`
    width: 11.51vw;
    height: auto;

    @media (max-width: 768px) {
        width: 40vw;
    }

    @media (max-width: 480px) {
        width: 60vw;
    }
`;

const AuthLogoTitle = styled.h1`
    font-size: ${FontSize.xxl};
    text-align: center;

    @media (max-width: 768px) {
        font-size: ${FontSize.xl};
        margin-bottom: 20px;
    }

    @media (max-width: 480px) {
        font-size: ${FontSize.lg};
        margin-bottom: 15px;
    }
`;

const AuthResendButton = styled(AntButton)`
    color: ${ThemesColors.mainBlueDark500};
`;

const AuthContainer = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    background: linear-gradient(90deg, #31b3ef 0%, #31b3ef 0.01%, #91d5f5 100%);
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    @media all and (max-width: 919.9px) {
        flex-direction: column;
    }
`;

const AuthLeftColumn = styled.div`
    width: 3%;
    background-color: ${ThemesColors.popoverBackground}
    height: 100vh;
    opacity: 0.4;

    @media all and (max-width: 919.9px) {
        width: 100%;
        height: 16px;
    }

`;

const AuthDescription = styled.div`
    flex: 1;
    margin-left: 49px;

    @media all and (max-width: 919.9px) {
        width: calc(100% - 52px);
        margin-left: 16px !important;
        margin-top: 26px;
        margin-bottom: 16px;
        margin-right: 16px;
    }
`;

const AuthImage = styled.img`
    width: 68.59px;
    height: 50.25px;
`;

const AuthTitle = styled.span`
    color: ${props => props.color};
    font-size: ${FontSize.xxx};
    font-family: ${FontFamily.baloo} !important;
    line-height: 65px;

    @media ${EDeviceSize.Desktop} {
        line-height: 40px;
        font-size: ${FontSize.xxl};
    }

    @media all and (max-width: 919.9px) {
        line-height: 27px;
        font-size: ${FontSize.lg};
    }
`;

const CreateNewPasswordSignInWrapper = styled.div`
    display: flex;

    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 10px;

    flex-direction: column;
`;
export {
    AuthIcon,
    AuthLogoTitle,
    AuthContainer,
    AuthLeftColumn,
    AuthDescription,
    AuthImage,
    AuthTitle,
    AuthCheckboxWrapper,
    AuthResendButton,
    CreateNewPasswordSignInWrapper,
};
